import { Component, Input, NgZone, ElementRef } from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from '../service/servicio'
import { LoginComponent } from '.././login/login.component'
import { UPLOAD_DIRECTIVES} from 'ng2-uploader';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppComponent } from '../app.component'
import { parametros } from '../datos/parametros';
import * as jsPDF from 'jspdf'


@Component({
  selector: 'app-visitas',
  templateUrl: './visitas.component.html',
  styleUrls: ['./visitas.component.css']
})
export class VisitasComponent  {
  muestraSoloHoy: boolean = false;
  cargado: boolean = false;

  constructor (public http: httpService,  public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

      this.toastr.setRootViewContainerRef(vcr);
      this.visitasHoy();
      //this.orden(6);


    };

    uploaded = {
      Status:0,
      Text:''

    }


    @Input() maquinas: any = [];

    maquinaSearch: string ='';
    place:string = 'Buscar por Cliente';

    mostrarLogin = true;

    sort: string = 'Descmarca';

    mensajeAlerta:string;
    logged:string;

    fechavisita = this.hoy();



    icon1:string ="glyphicon glyphicon-edit";

    ordenar(sort) {

      let campo1, campo2: any;

      this.maquinas.sort(function(a, b){

        switch (sort) {
        case "Id":
          campo1 = a.Id;
          campo2 = b.Id;
          break;
        case "Descmarca":
          campo1 = a.Descmarca;
          campo2 = b.Descmarca;
          break;
        case "Descmodelo":
        campo1 = a.Descmodelo;
        campo2 = b.Descmodelo;
          break;
        case "Desccliente":
        campo1 = a.Desccliente;
        campo2 = b.Desccliente;
          break;
        case "DescPosicion":
         campo1 = a.DescPosicion;
         campo2 = b.DescPosicion;
            break;
        default:
      }

        if ( campo1 < campo2 )
            return -1;
        if ( campo1 > campo2 )
            return 1;
        return 0;
      });

    }

    getUltimaRecaudacion() {
      let sql = 'SELECT IdMaquina, MAX(Fecha) AS Last FROM recaudaciones GROUP BY IdMaquina';
      return new Promise(resolve => {
        //let sql = "SELECT * from recaudaciones order by Fecha desc limit 0,1"
        this.http.doSql(sql).subscribe( recs => {
          resolve(recs)
        })
      })
    }

    ordenarMaquinas(maquinas: any) {
      maquinas.sort(function(a, b){
        if ( a.Desccliente < b.Desccliente )
          return -1;
        else
          return 1;
      }) 
    }
    
    compruebaVisitas(v, dayOfWeek, dayRec, defaultLast, hoy) {
      return new Promise( resolve => {
        if (v === '') {
          v = 'FFFFFFFFFF'
        } 
        let v1 = v[dayOfWeek];
        let v2 = v[dayOfWeek + 5]
        if ( v1 == 'V' || v2 == 'V') { // tiene el dia de semana de hoy a V
          if (v1 == 'V' && v2 == 'V') { // son todos los dia semana de hoy a V 
            let d1 = dayRec.getTime();
            let d2 = hoy.getTime();
            if (d1 !== d2) 
                resolve (true)
            else
                resolve(false)
          } else {
            let d1 = dayRec.getTime();
            let d2 = defaultLast.getTime();
            if (d1 >= d2 ) { // es uno si uno no, vemos si la ultima rec fue hace más 7 dias
              resolve(false)
            } else {
              resolve(true)
            }
          }
        } else {
          resolve(false)
        }
      })
    }

    volverCargas() {
      this.http.sw.mostrarVisitas = false;
      this.http.sw.mostrarCargasOperador = true;
    }

    async visitasHoy() {
      this.cargado = false;
      this.http.loading = true;
      let maquinas: any = await this.descargarMaquinas();
      this.ordenarMaquinas(maquinas);
      this.muestraSoloHoy = true;
      let fs = this.fechavisita+'T02:00:00'
      console.log(fs)
      const hoy = new Date(fs);
      let f = hoy.toDateString();
      let defaultLast = new Date(f);
      defaultLast.setDate(defaultLast.getDate() - 7);
      console.log(f, hoy, defaultLast)
      let dayOfWeek = hoy.getDay();
      if (dayOfWeek == 0 || dayOfWeek == 6) {
        this.maquinas = [];
        this.http.loading = false;
        this.cargado = true;
        this.toastr.warning('Horario Fin de Semana', 'Fuera de Horario');
      } else {
        dayOfWeek = dayOfWeek - 1;
        let maquinasFound = [];
        let recaudaciones: any = await this.getUltimaRecaudacion();
        console.log('maquinas: ', maquinas)
        console.log('RECAUDACIONES: ', recaudaciones)
        for (let i = 0; i < maquinas.length; i++) {
            let maq = maquinas[i];
            console.log('maq: ', maq)
            let rec = recaudaciones.filter(r => r.IdMaquina == maq.Id);
            let dayRec: Date;
            if (rec.length === 0) 
              dayRec = new Date('2023-01-01')
            else
              dayRec = new Date(rec[0].Last)
              let v = maq.visitas;
              let visita = await this.compruebaVisitas(v, dayOfWeek, dayRec, defaultLast, hoy)
              if (visita) 
                maquinasFound.push(maquinas[i]);

            if (i >= maquinas.length - 1) {
              console.log('Found: ', maquinasFound);
              this.maquinas = maquinasFound;
              this.http.loading = false;
              this.cargado = true;
              console.log('Found: ', maquinasFound, this.maquinas, this.cargado);
            }
        }
        
      }
    }

    listar() {

      // Only pt supported (not mm or in)

      let doc = new jsPDF('p', 'pt');

      doc.setFont("courier");
      doc.setFontSize(14);
      doc.setFontType("bold");

      doc.text(15,20,"Listado de Visitas dia " + this.fechavisita + "( " + this.maquinas.length + " )");
      //doc.text(500, 20, this.http.hoy())
      doc.line(15,25,585,25);

      let lineas:any = [];
      let y: number = 40;

      doc.setFontSize(10);
      doc.setFontType("normal");
    /*
      doc.text(0,5, '12345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890');
      doc.text(0,15,'         1         2         3         4         5         6         7         8         9         10       11        12        13        14');
      for (let i=0; i < 800; i+=10) {

        doc.text(i, 25,".");
        doc.text(5,i,".");
      }
      let ii:number = 0;
      let c:number = 0;

      for (let i=0; i < 800; i+=10) {
        ii ++;
        if (ii == 10) {
          c++;
          doc.text(i, 25, c.toString());
          doc.text(10, i, c.toString());

          ii = 0 };

      }
    */
      doc.setFontSize(10);
      doc.setFontType("bold");

      doc.text(15, y, 'Id');
      doc.text(40, y, 'Marca');
      doc.text(100, y, 'Modelo');
      doc.text(200, y, 'Cliente');
      doc.text(500, y, 'Visita');
      doc.line(15, y + 5, 585, y + 5)

     y = 60;
     doc.setFontType("normal");
     let sw:boolean =true;

    let tabla:any = this.maquinas; //this.filtro();


      tabla.forEach(visita => {
        if (sw) {
         doc.setTextColor(128,128,128)
       }else {
         doc.setTextColor(0,0,0)
       }
       let v = ''
       let ds = "LMXJVLMXJV"
       for (let i = 0; i<10; i++) {
         if (visita.visitas[i] == 'V') {
            if (v.length > 0) v = v + '-'
            v = v + ds[i];
         }
       }
       doc.text(15, y, visita.Id);
       doc.text(40, y, visita.Descmarca.slice(0,10));
       doc.text(100, y, visita.Descmodelo.slice(0,14));
       doc.text(200, y, visita.Desccliente.slice(0,48));
       doc.text(500, y, v);
       //doc.line(15, y + 8, 585, y + 8)


       sw = !sw;

       y+=20;
       if (y > 800)  { doc.addPage(); y = 35 }

      })


        doc.save('Visitas_' + this.fechavisita + '.pdf');

    }


    hoy() {

        let today = new Date();
        let dd = today.getDate().toString();
        let mm = (today.getMonth() + 1).toString();
        let yyyy:string;


        if(today.getDate() < 10) {

          dd = '0'+ dd;
        }

        if (today.getMonth() < 10) {
          mm = '0'+ mm;
        }

        yyyy = today.getFullYear().toString();

        let fecha = yyyy + '-' + mm + '-' + dd;


        return  fecha;

     }


    orden(n) {
      if (n == 1) { this.sort='Id'; this.place='Buscar por Id' };
      if (n == 2) { this.sort='Descmarca'; this.place='Buscar por Marca' };
      if (n == 3) { this.sort='Descmodelo'; this.place='Buscar por Modelo' };
      if (n == 4) { this.sort='DescPosicion'; this.place='Buscar por Posicion' };
      if (n == 5) { this.sort='Desccliente'; this.place='Buscar por Cliente' };
      if (n == 6) { this.sort='visita'; this.place='Buscar por Cliente' };
      this.ordenar(this.sort);

    }

   quitarfiltro(tipo: Number) {
      this.maquinaSearch = '';
      this.sort = 'Desccliente';
   }

   filtrarfecha() {
     this.sort='fecha';
   }

  filtro() {
      return this.maquinas.filter((maquina) => {

        if (this.sort == 'fecha') {
          return maquina.visita <= this.fechavisita;

        }
        if ((this.sort == 'Desccliente') || (this.sort == 'visita')) {
          if (maquina.Desccliente == null ) maquina.Desccliente = 'Sin asignar';
          return maquina.Desccliente.toLowerCase().indexOf(this.maquinaSearch.toLowerCase()) != -1;
        }
     });
  }


  descargarMaquinas() {
      return new Promise(resolve => {
        this.http.descargarMaquinas(0)
        .subscribe(maquina => {
                   this.maquinas = maquina.sort(function(a, b){
                       if ( a.visita > b.visita )
                           return -1;
                       if ( a.visita < b.visita )
                           return 1;
                       return 0;
                   });;
                  
              }, err => {
                resolve(null);
              }, () => {
                resolve(this.maquinas)
                  
        });
      })
  }




  }



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/visitas/visitas.component.ts